import {
  faFileAlt,
  faChartBar,
  faUser,
  faBed,
  faFlask,
  faFileInvoiceDollar,
  faUserTie,
  faHospital,
  faClipboardList,
  faStethoscope,
} from '@fortawesome/free-solid-svg-icons';

export const REPORT_ICON_OPTIONS = [
  { name: 'faFileAlt', icon: faFileAlt, label: 'Document' },
  { name: 'faChartBar', icon: faChartBar, label: 'Chart' },
  { name: 'faUser', icon: faUser, label: 'Patient' },
  { name: 'faBed', icon: faBed, label: 'Admission' },
  { name: 'faFlask', icon: faFlask, label: 'Lab' },
  { name: 'faFileInvoiceDollar', icon: faFileInvoiceDollar, label: 'Billing' },
  { name: 'faUserTie', icon: faUserTie, label: 'Staff' },
  { name: 'faHospital', icon: faHospital, label: 'Hospital' },
  { name: 'faClipboardList', icon: faClipboardList, label: 'List' },
  { name: 'faStethoscope', icon: faStethoscope, label: 'Clinical' },
];

const ICON_MAP = REPORT_ICON_OPTIONS.reduce((acc, option) => {
  acc[option.name] = option.icon;
  return acc;
}, {});

export function getReportIcon(name) {
  return ICON_MAP[name] || faFileAlt;
}
